import PropTypes from 'prop-types';
import { m, animate } from 'framer-motion';
import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import { bgGradient } from 'src/theme/css';

export default function HomeExperience({ title, total, icon, color = 'primary', sx, ...other }) {
  const theme = useTheme();
  const [ref, inView] = useInView({ triggerOnce: true });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (inView) {
      const animation = animate(0, total, {
        duration: 3,
        ease: 'easeOut',
        onUpdate: (value) => {
          setCount(Math.round(value));
        },
      });

      return () => animation.stop();
    }

    return undefined;
  }, [inView, total]);

  return (
    <Stack
      ref={ref}
      alignItems="center"
      sx={{
        ...bgGradient({
          direction: '135deg',
          startColor: alpha(theme.palette[color]?.light || theme.palette.primary.light, 0.2),
          endColor: alpha(theme.palette[color]?.main || theme.palette.primary.main, 0.2),
        }),
        py: 5,
        borderRadius: 2,
        textAlign: 'center',
        color: `${color}.darker`,
        backgroundColor: 'common.white',
        ...sx,
      }}
      {...other}
    >
      {icon && <Box sx={{ width: 50, height: 50, mb: 1 }}>{icon}</Box>}

      <Typography
        component={m.div}
        variant="h2"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          opacity: 0.64,
        }}
      >
        {`${count} +`}
      </Typography>

      <Typography variant="subtitle1" sx={{ opacity: 0.64 }}>
        {title}
      </Typography>
    </Stack>
  );
}

HomeExperience.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sx: PropTypes.object,
  title: PropTypes.string,
  total: PropTypes.number,
};
